import React from "react";
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiDribbble,
  FiLinkedin,
  FiGitPullRequest,
  FiGithub,
  FiCode,
} from "react-icons/fi";

const SocialShare = [
  {
    iconName: <FiFacebook />,
    link: "https://www.facebook.com/ahmmedabir.09",
  },
  { iconName: <FiGithub />, link: "https://github.com/ahmmedabir9" },
  {
    iconName: <FiLinkedin />,
    link: "https://www.linkedin.com/in/abu-musa-ahmed-abir-524897138/",
  },
  {
    iconName: <FiCode />,
    link: "https://stackoverflow.com/users/11701032/ahmmed-abir",
  },
];
const Social = () => {
  return (
    <ul>
      {SocialShare.map((val, i) => (
        <li key={i}>
          <a href={val.link} target="_blank">
            {val.iconName}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Social;
